import { useCallback, useContext } from "react";
import { UserContext } from "../../contexts/UserContext";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useFetchCloudUserDetails = () => {
  const { setUserDetails } = useContext(UserContext);

  return useCallback(
    async (accessToken) => {
      try {
          const response = await axios.get(`${WiMuleSQL}/User/CurrentUser`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });

        const data = response.data;


        if (data?.data) {
          setUserDetails((prev) => ({
            ...prev,
            userId: data.data.id,
            userEmail: data.data.email,
            userName: data.data.userName,
            userCompany: data.data.company,
            userDepartment: data.data.department,
            userPosition: data.data.position,
            userAccessLevel: data.data.accessLevel,
            userImage: null,
          }));
        }

        return data?.data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    [setUserDetails]
  );
};
